module.exports = __webpack_public_path__ + "/build/web/images/recently-posted@3x.50ae736f618e0cd39b5caef1f05713a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/recently-posted@3x.jpg
// module id = 190
// module chunks = 13